import React from "react";
import "./genre-label.scss";
type GenreLabelProps = { genre: string | undefined };
const GenreLabel: React.FC<GenreLabelProps> = ({ genre }) => {
  const convertToHex = (str: string) => {
    var hex = "";
    for (var i = 0; i < str.length; i++) {
      hex += "" + str.charCodeAt(i).toString(16);
    }
    return hex;
  };
  return (
    <div
      style={{
        backgroundColor:
          "#" + (genre != null ? convertToHex(genre).slice(0, 6) : ""),
      }}
      className={"genre-label"}
    >
      <div className={"genre"}>{genre}</div>
    </div>
  );
};
export default GenreLabel;
